// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { formatDistance as fn } from "../formatDistance.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const formatDistance = convertToFP(fn, 2);

// Fallback for modularized imports:
export default formatDistance;
